import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

interface EnumState {
  data: [] | null;
  enumDataBySearch: [] | null;
}

const initialState: EnumState = {
  data: null,
  enumDataBySearch: null
};

export const enums = createSlice({
  name: 'enumData',
  initialState,
  reducers: {
    setEnumData: (state, action) => {
      state.data = action.payload;
    },
    setEnumDataBySearch: (state, action) => {
      state.enumDataBySearch = action.payload.data.data;
    },
    reset: (state) => {
      state = initialState;
    }
  }
});

export const { setEnumData, setEnumDataBySearch, reset } = enums.actions;

export const getEnumDataStore = (state: any) => state;
export const getSpecificEnumData = (state: RootState) => state.enum.data;
export const getEnumDataBySearch = (state: RootState) =>
  state.enum.enumDataBySearch;

export default enums.reducer;
